module.exports = __webpack_public_path__ + "static/media/brjostvodvar.b07c0cfc.png";